export const marketingMessages = {
  'Google y la IA leen tu sitio igual': [
    'Google and AI read your site the same way',
    'Google e IA leem seu site da mesma forma',
  ],
  'Rastreo, indexación, datos estructurados y velocidad: lo que necesita Google para posicionarte es lo que necesita un motor de IA para leerte y citarte. Google lo dijo en su guía de 2026 para AI Overviews y AI Mode: optimizar para su IA sigue siendo SEO.':
    [
      "Crawling, indexing, structured data and speed: what Google needs to rank you is what AI engines need to read and cite you. Google's 2026 guide for AI Overviews and AI Mode confirms that optimizing for its AI remains SEO.",
      'Rastreamento, indexação, dados estruturados e velocidade: o que o Google precisa para posicionar você é o que a IA precisa para ler e citar sua marca. O guia de 2026 do Google para AI Overviews e AI Mode confirma que otimizar para sua IA continua sendo SEO.',
    ],
  'Dos canales, un mismo cliente': [
    'Two channels, one customer',
    'Dois canais, um mesmo cliente',
  ],
  'La keyword que quieres posicionar en Google es la pregunta que tus clientes le hacen a ChatGPT. Verlas juntas te dice dónde ya ganas, dónde pierdes y qué contenido mueve los dos resultados a la vez.':
    [
      'The keyword you want to rank for is the question your customers ask ChatGPT. Seeing both shows where you win, where you lose and which content improves both results.',
      'A keyword que você quer posicionar no Google é a pergunta que seus clientes fazem ao ChatGPT. Ver ambas mostra onde você ganha, onde perde e qual conteúdo melhora os dois resultados.',
    ],
  'Una herramienta en vez de dos': [
    'One tool instead of two',
    'Uma ferramenta em vez de duas',
  ],
  'Sin pagar dos suscripciones, exportar planillas ni cruzar datos a mano. La auditoría, Search Console, tus posiciones y tu visibilidad en la IA viven en el mismo lugar y alimentan el mismo plan de acción.':
    [
      'One subscription, without exporting spreadsheets or combining data manually. Your audit, Search Console, rankings and AI visibility live together and inform one action plan.',
      'Uma assinatura, sem exportar planilhas nem cruzar dados manualmente. Auditoria, Search Console, posições e visibilidade em IA ficam juntos e alimentam o mesmo plano de ação.',
    ],
  '01 / Por qué juntos': ['01 / Why together', '01 / Por que juntos'],
  'El SEO es la base del AEO.': [
    'SEO is the foundation of AEO.',
    'O SEO é a base do AEO.',
  ],
  'Trabájalos en el mismo lugar.': [
    'Manage them together.',
    'Trabalhe os dois no mesmo lugar.',
  ],
  'Quien busca SEO hoy también necesita aparecer en las respuestas de la IA. Bison reúne los dos.':
    [
      'Anyone investing in SEO also needs to appear in AI answers. Bison brings both together.',
      'Quem investe em SEO também precisa aparecer nas respostas de IA. O Bison reúne os dois.',
    ],
  'Que te encuentren en Google.': [
    'Get found on Google.',
    'Seja encontrado no Google.',
  ],
  'Y que te cite la IA.': ['Get cited by AI.', 'Seja citado pela IA.'],
  '03 / Auditoría técnica': ['03 / Technical audit', '03 / Auditoria técnica'],
  'Ocho causas por las': ['Eight reasons why', 'Oito motivos pelos quais'],
  que: ['that', 'a'],
  'la IA no te lee.': ['AI cannot read you.', 'a IA não lê você.'],
  'Las mismas que ves en tu dashboard. Cada una con lo que miramos exactamente y desde qué plan está incluida.':
    [
      'The same checks in your dashboard, with exactly what we examine and which plans include them.',
      'As mesmas verificações do dashboard, com o que analisamos e quais planos as incluem.',
    ],
  'La auditoría es una parte del dashboard.': [
    'The audit is one part of the dashboard.',
    'A auditoria é uma parte do dashboard.',
  ],
  'Ver qué más mide la plataforma': [
    'See what else the platform measures',
    'Veja o que mais a plataforma mede',
  ],
  '04 / Datos de Google': ['04 / Google data', '04 / Dados do Google'],
  'Tu búsqueda clásica,': [
    'Your traditional search,',
    'Sua busca tradicional,',
  ],
  'al lado de la IA.': ['alongside AI.', 'ao lado da IA.'],
  'Conectas tus propiedades una vez y Bison lee los datos oficiales de Google. Sin instalar nada en tu sitio, sin planillas.':
    [
      'Connect your properties once and Bison reads official Google data. No installation or spreadsheets.',
      'Conecte suas propriedades uma vez e o Bison lê os dados oficiais do Google. Sem instalação nem planilhas.',
    ],
  '09 / Preguntas frecuentes': [
    '09 / Frequently asked questions',
    '09 / Perguntas frequentes',
  ],
  'SEO y AEO,': ['SEO and AEO,', 'SEO e AEO,'],
  'sin confusiones.': ['clearly explained.', 'sem confusão.'],
  'Qué herramientas de SEO trae Bison y por qué conviene trabajar SEO y AEO en el mismo lugar.':
    [
      'Which SEO tools Bison includes and why managing SEO and AEO together helps.',
      'Quais ferramentas de SEO o Bison inclui e por que trabalhar SEO e AEO juntos.',
    ],
  '06 / Del hallazgo a la acción': [
    '06 / From finding to action',
    '06 / Do achado à ação',
  ],
  'La auditoría no termina en un informe.': [
    'The audit goes beyond a report.',
    'A auditoria vai além de um relatório.',
  ],
  'Termina en el plan.': ['It becomes your plan.', 'Ela vira seu plano.'],
  'Cada revisión que falla se convierte en una acción con impacto y esfuerzo, y lo que se corrige se mide con los mismos datos de Google.':
    [
      'Every failed check becomes an action with impact and effort estimates. Fixes are measured with the same Google data.',
      'Cada verificação que falha vira uma ação com impacto e esforço. As correções são medidas com os mesmos dados do Google.',
    ],
  'El plan de acción ordena todo lo demás.': [
    'The action plan sets every priority.',
    'O plano de ação define as prioridades.',
  ],
  'Cómo se prioriza en la metodología': [
    'How the methodology sets priorities',
    'Como a metodologia define prioridades',
  ],
  'Google y la IA en un solo panel': [
    'Google and AI in one dashboard',
    'Google e IA em um só painel',
  ],
  'SEO y AEO en': ['SEO and AEO in', 'SEO e AEO em'],
  'una sola plataforma.': ['one platform.', 'uma única plataforma.'],
  'Auditoría de SEO técnico, Search Console, keywords, posiciones en Google y backlinks, junto a tu visibilidad en ChatGPT, Gemini y Perplexity. Todo lo que necesitas para que te encuentren en Google y te citen en la IA, sin pagar ni consultar dos herramientas.':
    [
      'Technical SEO audits, Search Console, keywords, Google rankings and backlinks alongside visibility in ChatGPT, Gemini and Perplexity. Everything you need to be found in Google and cited by AI, in one tool.',
      'Auditoria de SEO técnico, Search Console, keywords, posições no Google e backlinks junto da visibilidade no ChatGPT, Gemini e Perplexity. Tudo para ser encontrado no Google e citado pela IA em uma ferramenta.',
    ],
  'Ver las herramientas': ['Explore the tools', 'Conheça as ferramentas'],
  'Herramientas SEO': ['SEO tools', 'Ferramentas SEO'],
  'Auditoría, keywords, posiciones, backlinks': [
    'Audits, keywords, rankings, backlinks',
    'Auditoria, keywords, posições, backlinks',
  ],
  'Las que Google y la IA necesitan': [
    'The checks Google and AI need',
    'As verificações que Google e IA precisam',
  ],
  'Motores de IA': ['AI engines', 'Motores de IA'],
  'En el mismo panel que tu SEO': [
    'In the same dashboard as SEO',
    'No mesmo painel do seu SEO',
  ],
  Herramientas: ['Tools', 'Ferramentas'],
  'En vez de dos': ['Instead of two', 'Em vez de duas'],
  '02 / Herramientas': ['02 / Tools', '02 / Ferramentas'],
  'Todo tu SEO,': ['All your SEO,', 'Todo o seu SEO,'],
  'dentro de Bison.': ['inside Bison.', 'dentro do Bison.'],
  'De la auditoría técnica a las keywords, las posiciones y los backlinks: las herramientas que usas para Google, en la misma plataforma que mide tu visibilidad en la IA.':
    [
      'From technical audits to keywords, rankings and backlinks: the tools you use for Google, in the platform that measures your AI visibility.',
      'Da auditoria técnica às keywords, posições e backlinks: suas ferramentas do Google na plataforma que mede sua visibilidade em IA.',
    ],
  '08 / Lecturas': ['08 / Further reading', '08 / Leituras'],
  'Lo que escribimos': ['What we write', 'O que escrevemos'],
  'sobre SEO técnico y la IA.': [
    'about technical SEO and AI.',
    'sobre SEO técnico e IA.',
  ],
  'Guías del equipo con fuentes citadas: schema.org, llms.txt, robots.txt, crawlers y cómo medir con las herramientas gratuitas de Google.':
    [
      "Team guides with cited sources: schema.org, llms.txt, robots.txt, crawlers and measurement with Google's free tools.",
      'Guias da equipe com fontes citadas: schema.org, llms.txt, robots.txt, crawlers e medição com ferramentas gratuitas do Google.',
    ],
  'Análisis, guías y notas de actualidad.': [
    'Analysis, guides and news.',
    'Análises, guias e notícias.',
  ],
  'Ir al blog': ['Visit the blog', 'Ir para o blog'],
  '05 / Un solo panel': ['05 / One dashboard', '05 / Um só painel'],
  'Lo que mides en Google,': [
    'What you measure in Google,',
    'O que você mede no Google,',
  ],
  'al lado de lo que pasa en la IA.': [
    'alongside what happens in AI.',
    'ao lado do que acontece na IA.',
  ],
  'Cada métrica de SEO tiene su equivalente en los motores generativos. En Bison las ves juntas, para la misma marca y las mismas preguntas.':
    [
      'Every SEO metric has a generative engine counterpart. Bison shows them together for the same brand and questions.',
      'Cada métrica de SEO tem um equivalente nos motores generativos. O Bison mostra ambas para a mesma marca e as mesmas perguntas.',
    ],
  'Métricas de SEO y su equivalente en la visibilidad en IA': [
    'SEO metrics and their AI visibility counterparts',
    'Métricas de SEO e seus equivalentes na visibilidade em IA',
  ],
  'En Google': ['In Google', 'No Google'],
  '07 / Qué entra en cada plan': [
    '07 / Included in each plan',
    '07 / O que cada plano inclui',
  ],
  'Search Console desde Scout.': [
    'Search Console from Scout.',
    'Search Console a partir do Scout.',
  ],
  'La auditoría, desde Radar.': [
    'Audits from Radar.',
    'Auditoria a partir do Radar.',
  ],
  'Las herramientas de SEO que incluye cada plan.': [
    'SEO tools included in each plan.',
    'Ferramentas de SEO incluídas em cada plano.',
  ],
  'Precios y alcance completo de cada plan.': [
    'Pricing and full scope of each plan.',
    'Preços e escopo completo de cada plano.',
  ],
  'Ver planes y precios': ['View plans and pricing', 'Ver planos e preços'],
  'Las ocho revisiones que Google y la IA necesitan': [
    'The eight checks Google and AI need',
    'As oito verificações que Google e IA precisam',
  ],
  'Bots de IA, indexación, sitemap, HTTPS, datos estructurados, estructura semántica, llms.txt y velocidad, con el estado de cada una y su acción en el plan.':
    [
      'AI bots, indexing, sitemap, HTTPS, structured data, semantic structure, llms.txt and speed, each with its status and planned action.',
      'Bots de IA, indexação, sitemap, HTTPS, dados estruturados, estrutura semântica, llms.txt e velocidade, cada um com status e ação no plano.',
    ],
  'Clics, impresiones, CTR y posición': [
    'Clicks, impressions, CTR and position',
    'Cliques, impressões, CTR e posição',
  ],
  'Tus consultas y páginas con más tráfico, la serie diaria y la inspección de URL de tus páginas clave, sin salir de Bison.':
    [
      'Your top queries and pages, daily trends and key-page URL inspection, without leaving Bison.',
      'Suas principais consultas e páginas, séries diárias e inspeção de URLs importantes, sem sair do Bison.',
    ],
  'Investigación de keywords y volumen de búsqueda': [
    'Keyword research and search volume',
    'Pesquisa de keywords e volume de busca',
  ],
  'Qué buscan tus clientes en Google y cuánto, conectado con las preguntas que ya monitoreas en ChatGPT, Gemini y Perplexity.':
    [
      'What customers search for in Google and how often, connected to questions you track in ChatGPT, Gemini and Perplexity.',
      'O que seus clientes buscam no Google e com qual frequência, conectado às perguntas monitoradas no ChatGPT, Gemini e Perplexity.',
    ],
  'Seguimiento de posiciones en Google': [
    'Google rank tracking',
    'Monitoramento de posições no Google',
  ],
  'Tu posición en los resultados de Google al lado de tu posición dentro de la respuesta de la IA, para la misma pregunta.':
    [
      'Your position in Google results alongside your position in AI answers for the same question.',
      'Sua posição nos resultados do Google ao lado da posição nas respostas de IA para a mesma pergunta.',
    ],
  'Quién enlaza tu sitio': [
    'Who links to your site',
    'Quem inclui links para seu site',
  ],
  'Los enlaces que apuntan a tu dominio junto a las fuentes que la IA cita, para decidir dónde ganar presencia primero.':
    [
      'Links to your domain alongside AI citation sources, to decide where to build presence first.',
      'Links para seu domínio junto das fontes citadas pela IA para decidir onde ganhar presença primeiro.',
    ],
  'Todas tus páginas, no solo una': ['All your pages', 'Todas as suas páginas'],
  'Enlaces rotos, redirecciones, canonicals, contenido duplicado y hreflang en el sitio completo.':
    [
      'Broken links, redirects, canonicals, duplicate content and hreflang across your site.',
      'Links quebrados, redirecionamentos, canonicals, conteúdo duplicado e hreflang em todo o site.',
    ],
  'PageSpeed y Core Web Vitals': [
    'PageSpeed and Core Web Vitals',
    'PageSpeed e Core Web Vitals',
  ],
  'Puntajes de Lighthouse en móvil y escritorio, métricas de carga y las oportunidades con más impacto.':
    [
      'Mobile and desktop Lighthouse scores, loading metrics and the highest-impact opportunities.',
      'Scores do Lighthouse em dispositivos móveis e computadores, métricas de carregamento e oportunidades de maior impacto.',
    ],
  'La experiencia de tus usuarios reales': [
    "Your real users' experience",
    'A experiência dos seus usuários reais',
  ],
  'LCP, INP y CLS medidos con visitas reales, además de la medición de laboratorio.':
    [
      'LCP, INP and CLS from real visits alongside lab measurement.',
      'LCP, INP e CLS de visitas reais junto da medição de laboratório.',
    ],
  'Schema.org detectado, auditado y generado': [
    'Schema.org detected, audited and generated',
    'Schema.org detectado, auditado e gerado',
  ],
  'Lo que ya tienes, lo que está mal y el JSON-LD que falta para que Google y la IA resuelvan tu marca.':
    [
      'What exists, what needs fixing and the missing JSON-LD for Google and AI to identify your brand.',
      'O que existe, o que precisa de correção e o JSON-LD que falta para Google e IA identificarem sua marca.',
    ],
  'Keywords y volumen de búsqueda': [
    'Keywords and search volume',
    'Keywords e volume de busca',
  ],
  'Preguntas monitoreadas en cada motor': [
    'Questions tracked in each engine',
    'Perguntas monitoradas em cada motor',
  ],
  'Posición en los resultados de Google': [
    'Position in Google results',
    'Posição nos resultados do Google',
  ],
  'Posición dentro de la respuesta de la IA': [
    'Position within AI answers',
    'Posição dentro das respostas de IA',
  ],
  'Backlinks hacia tu dominio': [
    'Backlinks to your domain',
    'Backlinks para seu domínio',
  ],
  'Fuentes que la IA cita': ['Sources cited by AI', 'Fontes citadas pela IA'],
  'Clics e impresiones en Search Console': [
    'Search Console clicks and impressions',
    'Cliques e impressões no Search Console',
  ],
  'Visitas desde ChatGPT, Gemini y Perplexity en GA4': [
    'Visits from ChatGPT, Gemini and Perplexity in GA4',
    'Visitas de ChatGPT, Gemini e Perplexity no GA4',
  ],
  'Indexación, sitemap y velocidad': [
    'Indexing, sitemap and speed',
    'Indexação, sitemap e velocidade',
  ],
  'Acceso de los bots de IA y llms.txt': [
    'AI bot access and llms.txt',
    'Acesso de bots de IA e llms.txt',
  ],
  'Datos estructurados para resultados enriquecidos': [
    'Structured data for rich results',
    'Dados estruturados para resultados avançados',
  ],
  'Datos estructurados para que la IA resuelva tu marca': [
    'Structured data to help AI identify your brand',
    'Dados estruturados para a IA identificar sua marca',
  ],
  'Desde Radar': ['From Radar', 'A partir do Radar'],
  'Desde Scout': ['From Scout', 'A partir do Scout'],
  'La búsqueda clásica al lado de la IA': [
    'Traditional search alongside AI',
    'Busca tradicional ao lado da IA',
  ],
  'Clics, impresiones, CTR y posición media de los últimos 28 días, top consultas y páginas, serie diaria e inspección de URL. Lectura directa de tu propiedad, sin instalar nada.':
    [
      'Clicks, impressions, CTR and average position over 28 days, top queries and pages, daily trends and URL inspection. Direct property access with no installation.',
      'Cliques, impressões, CTR e posição média em 28 dias, principais consultas e páginas, séries diárias e inspeção de URLs. Leitura direta da sua propriedade, sem instalação.',
    ],
  'Tráfico humano y tráfico de IA': [
    'Human and AI traffic',
    'Tráfego humano e de IA',
  ],
  'Sesiones por fuente y fecha, separadas entre buscadores clásicos y visitas que llegan desde ChatGPT, Perplexity y los demás motores. Para ver si la visibilidad en IA se convierte en visitas.':
    [
      'Sessions by source and date, separating traditional search engines from ChatGPT, Perplexity and other AI visits, to see whether AI visibility converts into visits.',
      'Sessões por fonte e data, separando buscadores tradicionais de visitas de ChatGPT, Perplexity e outros motores de IA, para ver se a visibilidade gera visitas.',
    ],
  'Velocidad con el motor de Google': [
    "Speed with Google's engine",
    'Velocidade com o motor do Google',
  ],
  'Puntajes de Lighthouse en móvil y escritorio, métricas de carga y las oportunidades con más impacto. Es la misma herramienta pública de Google, integrada en tu auditoría.':
    [
      "Mobile and desktop Lighthouse scores, loading metrics and top opportunities. Google's public tool, built into your audit.",
      'Scores do Lighthouse em dispositivos móveis e computadores, métricas de carregamento e principais oportunidades. A ferramenta pública do Google integrada à auditoria.',
    ],
  Auditar: ['Audit', 'Auditar'],
  'Las ocho revisiones técnicas sobre tu sitio, con el estado de cada una.': [
    'Eight technical site checks with individual statuses.',
    'Oito verificações técnicas do site com status individual.',
  ],
  Priorizar: ['Prioritize', 'Priorizar'],
  'Cada hallazgo entra al plan de acción con impacto y esfuerzo, ordenado por semana, mes y trimestre.':
    [
      'Each finding enters your action plan with impact and effort, organized by week, month and quarter.',
      'Cada achado entra no plano de ação com impacto e esforço, organizado por semana, mês e trimestre.',
    ],
  Generar: ['Generate', 'Gerar'],
  'El schema.org que falta y las preguntas frecuentes que responden lo que la IA todavía no encuentra en tu sitio.':
    [
      'Missing schema.org and FAQs answering what AI cannot yet find on your site.',
      'O schema.org que falta e FAQs que respondem ao que a IA ainda não encontra no seu site.',
    ],
  Medir: ['Measure', 'Medir'],
  'Search Console y GA4 al lado del Score de visibilidad: si la base técnica mejoró, se ve en ambos.':
    [
      'Search Console and GA4 alongside your visibility score: technical improvements show in both.',
      'Search Console e GA4 ao lado do score de visibilidade: melhorias técnicas aparecem em ambos.',
    ],
  'Leemos tu robots.txt y comprobamos si GPTBot, Google-Extended, ClaudeBot, PerplexityBot, CCBot y Applebot-Extended pueden rastrear, y si declaras tu sitemap. Un bloqueo accidental te saca de las respuestas antes de empezar.':
    [
      'We read robots.txt to check access for GPTBot, Google-Extended, ClaudeBot, PerplexityBot, CCBot and Applebot-Extended and whether your sitemap is declared. An accidental block can exclude you from answers.',
      'Lemos robots.txt para verificar acesso de GPTBot, Google-Extended, ClaudeBot, PerplexityBot, CCBot e Applebot-Extended e se o sitemap está declarado. Um bloqueio acidental pode excluir sua marca das respostas.',
    ],
  'Inspección de URL por Search Console: veredicto de cobertura, último rastreo y resultados enriquecidos de las páginas que importan, y detección de páginas que solo existen tras ejecutar JavaScript.':
    [
      'Search Console URL inspection: coverage verdict, last crawl, key-page rich results and detection of pages that exist only after JavaScript runs.',
      'Inspeção de URLs pelo Search Console: cobertura, último rastreamento, resultados avançados de páginas importantes e detecção de páginas que só existem após executar JavaScript.',
    ],
  'Lo buscamos en robots.txt y en las rutas habituales, lo leemos y revisamos que incluya las páginas legales, de producto y de contacto, que tenga fechas de modificación y que nombre tu llms.txt.':
    [
      'We find and read your sitemap, checking legal, product and contact pages, modification dates and the reference to llms.txt.',
      'Encontramos e lemos o sitemap, verificando páginas legais, de produto e contato, datas de modificação e referência ao llms.txt.',
    ],
  'Validez del certificado y comportamiento de la redirección de HTTP a HTTPS.':
    [
      'Certificate validity and HTTP-to-HTTPS redirect behavior.',
      'Validade do certificado e comportamento do redirecionamento de HTTP para HTTPS.',
    ],
  'Detectamos el JSON-LD que ya tienes, lo auditamos y clasificamos por tipo, y generamos el que falta: Organization, Product, FAQPage y los demás que los motores usan para resolver tu entidad.':
    [
      'We detect, audit and classify existing JSON-LD, then generate missing types: Organization, Product, FAQPage and others engines use to identify your entity.',
      'Detectamos, auditamos e classificamos o JSON-LD existente e geramos os tipos ausentes: Organization, Product, FAQPage e outros usados pelos motores para identificar sua entidade.',
    ],
  'Por página: jerarquía de encabezados, etiquetas semánticas, largo del title y la meta description, presencia de canonical, meta robots y Open Graph, textos alternativos y atributo de idioma.':
    [
      'Per page: heading hierarchy, semantic tags, title and description length, canonical, robots and Open Graph metadata, alt text and language attribute.',
      'Por página: hierarquia de títulos, tags semânticas, tamanho de title e description, canonical, metadados robots e Open Graph, textos alternativos e atributo de idioma.',
    ],
  'Comprobamos que llms.txt y llms-full.txt existan y calificamos su contenido de 0 a 100: identidad, productos, preguntas frecuentes y enlaces canónicos que un agente puede citar.':
    [
      'We check llms.txt and llms-full.txt and rate content from 0–100: identity, products, FAQs and canonical links an agent can cite.',
      'Verificamos llms.txt e llms-full.txt e avaliamos o conteúdo de 0 a 100: identidade, produtos, FAQs e links canônicos que um agente pode citar.',
    ],
  'PageSpeed Insights con el motor de Lighthouse: puntajes por categoría, FCP, LCP, TBT, CLS y Speed Index, y las cinco oportunidades con más impacto. Medición de laboratorio, no de usuarios reales.':
    [
      'PageSpeed Insights with Lighthouse: category scores, FCP, LCP, TBT, CLS, Speed Index and the five highest-impact opportunities. Lab measurement, rather than real-user data.',
      'PageSpeed Insights com Lighthouse: scores por categoria, FCP, LCP, TBT, CLS, Speed Index e as cinco oportunidades de maior impacto. Medição de laboratório, sem dados de usuários reais.',
    ],
  COD: ['CODE', 'CÓD.'],
  ARQUETIPO: ['ARCHETYPE', 'ARQUÉTIPO'],
  'FOCO PRINCIPAL': ['MAIN FOCUS', 'FOCO PRINCIPAL'],
  'ACCIONES BASICAS': ['BASIC ACTIONS', 'AÇÕES BÁSICAS'],
  TIEMPO: ['TIME', 'TEMPO'],
  OBJETIVO: ['GOAL', 'OBJETIVO'],
  '05 / Modelos de negocio': [
    '05 / Business models',
    '05 / Modelos de negócio',
  ],
  'Seis tipos de marca.': ['Six brand types.', 'Seis tipos de marca.'],
  'Seis secuencias': ['Six sequences', 'Seis sequências'],
  'propias.': ['of their own.', 'próprias.'],
  'Las acciones son las mismas para todos. Lo que cambia es el orden — y ese orden depende de tu arquetipo. Lo que es urgente para un SaaS B2B no lo es para un negocio local ni para un e-commerce.':
    [
      'The actions are the same; their order depends on your archetype. What is urgent for B2B SaaS differs from a local business or online store.',
      'As ações são as mesmas; a ordem depende do seu arquétipo. O que é urgente para SaaS B2B é diferente de um negócio local ou e-commerce.',
    ],
  Descubrimiento: ['Discovery', 'Descoberta'],
  'Prompts sobre tu categoría sin mencionar ninguna marca. Mide si apareces espontáneamente cuando alguien describe el problema que resuelves, antes de que piense en ti.':
    [
      'Category prompts without brand names measure whether you appear spontaneously when someone describes the problem you solve.',
      'Prompts da categoria sem nomes de marcas medem se você aparece espontaneamente quando alguém descreve o problema que você resolve.',
    ],
  'Prompts que mencionan directamente tu marca. Establece qué sabe el modelo de ti, cómo te describe y si te reconoce como entidad con autoridad verificable en la categoría.':
    [
      'Prompts naming your brand establish what the model knows, how it describes you and whether it recognizes your verifiable authority in the category.',
      'Prompts que citam sua marca mostram o que o modelo sabe, como descreve você e se reconhece sua autoridade verificável na categoria.',
    ],
  'Prompts comparativos entre marcas. Revelan cómo el modelo te posiciona frente a competidores directos y qué atributos diferenciadores prioriza en cada respuesta.':
    [
      'Brand comparison prompts reveal your position against direct competitors and the differentiating attributes each answer prioritizes.',
      'Prompts comparativos entre marcas revelam sua posição frente à concorrência e os atributos diferenciadores priorizados em cada resposta.',
    ],
  'Prompts sobre experiencia de clientes y confiabilidad. Mide cómo los modelos perciben tu marca a partir de reseñas, casos y menciones en fuentes externas verificables.':
    [
      'Customer experience and reliability prompts measure perception based on reviews, cases and mentions in verifiable external sources.',
      'Prompts sobre experiência do cliente e confiabilidade medem a percepção com base em avaliações, casos e menções em fontes externas verificáveis.',
    ],
  '06 / Tipos de prompt': ['06 / Prompt types', '06 / Tipos de prompt'],
  'Cuatro categorías.': ['Four categories.', 'Quatro categorias.'],
  'Distintos objetivos.': ['Different goals.', 'Objetivos diferentes.'],
  'No todos los prompts aportan lo mismo. Según la etapa, contexto y objetivos de tu marca, algunos tipos de medición son más urgentes que otros. Estas cuatro categorías guían cómo priorizamos el trabajo.':
    [
      "Not all prompts contribute equally. Your brand's stage, context and goals determine which measurements are most urgent. Four categories guide our priorities.",
      'Nem todos os prompts contribuem igualmente. Etapa, contexto e objetivos da marca definem as medições mais urgentes. Quatro categorias orientam nossas prioridades.',
    ],
  'Diagnóstico 0–100 baseline': [
    '0–100 baseline diagnosis',
    'Diagnóstico inicial 0–100',
  ],
  'Aplicar la matriz de 4 dimensiones. Definir mínimos absolutos. Clasificar arquetipo. Salida: severidad + foco trimestral.':
    [
      'Apply the 4-dimension matrix, define minimums and classify the archetype. Output: severity and quarterly focus.',
      'Aplicar a matriz de 4 dimensões, definir mínimos e classificar o arquétipo. Resultado: severidade e foco trimestral.',
    ],
  'Brechas técnicas + editoriales': [
    'Technical + editorial gaps',
    'Lacunas técnicas + editoriais',
  ],
  'Schema, llms.txt, sameAs, reseñas, Wikipedia, prensa. Cada brecha con esfuerzo en horas e impacto en puntos.':
    [
      'Schema, llms.txt, sameAs, reviews, Wikipedia and press. Each gap has effort in hours and impact in points.',
      'Schema, llms.txt, sameAs, avaliações, Wikipédia e imprensa. Cada lacuna tem esforço em horas e impacto em pontos.',
    ],
  'Activar acciones en paralelo': [
    'Activate parallel actions',
    'Ativar ações em paralelo',
  ],
  'Seleccionadas de la biblioteca de 25, según arquetipo. Cada una con una condición explícita que activa la siguiente. Incluye la generación del contenido para cerrar las brechas.':
    [
      'Selected from 25 actions for your archetype. Each has explicit criteria activating the next, including content generation to close gaps.',
      'Selecionadas de 25 ações para seu arquétipo. Cada uma tem critérios explícitos para ativar a próxima, incluindo geração de conteúdo para fechar lacunas.',
    ],
  'Acumular citas verificables': [
    'Build verifiable citations',
    'Acumular citações verificáveis',
  ],
  'Reporte semanal con cobertura por motor, share-of-voice, posición media. Comparativa contra 3–5 competidores.':
    [
      'Weekly engine coverage, share of voice and average position reports, comparing 3–5 competitors.',
      'Relatórios semanais de cobertura por motor, share of voice e posição média, comparando 3–5 concorrentes.',
    ],
  '04 / Ciclo Operativo': ['04 / Operating cycle', '04 / Ciclo operacional'],
  'El ciclo': ['The cycle', 'O ciclo'],
  'ejecuta cada trimestre.': [
    'runs every quarter.',
    'se repete a cada trimestre.',
  ],
  'El AEO no es un proyecto, es una práctica. Diagnosticar, auditar, optimizar y posicionar son cuatro fases que se repiten cada 90 días: cada fase activa la siguiente cuando la anterior alcanza su umbral.':
    [
      'AEO is an ongoing practice. Diagnosis, audit, optimization and positioning repeat every 90 days; each phase activates the next when its threshold is met.',
      'AEO é uma prática contínua. Diagnosticar, auditar, otimizar e posicionar se repetem a cada 90 dias; cada fase ativa a próxima ao atingir seu limite.',
    ],
  '¿Existe la marca como entidad única?': [
    'Does the brand exist as a unique entity?',
    'A marca existe como entidade única?',
  ],
  'RUT, INAPI, registros públicos. Schema.org completo, llms.txt publicado, directorios consistentes (Crunchbase, Tracxn). Sin esto, los LLMs no resuelven entidad: te confunden con otras marcas o no te citan.':
    [
      'Legal and public records, complete Schema.org, published llms.txt and consistent directories (Crunchbase, Tracxn). Without them, LLMs may confuse your brand or omit citations.',
      'Registros legais e públicos, Schema.org completo, llms.txt publicado e diretórios consistentes (Crunchbase, Tracxn). Sem eles, LLMs podem confundir sua marca ou omitir citações.',
    ],
  'Sin schema, sin llms.txt, nombre confundible': [
    'No schema or llms.txt; ambiguous name',
    'Sem schema ou llms.txt; nome ambíguo',
  ],
  'Identidad legal limpia, schema parcial': [
    'Clear legal identity, partial schema',
    'Identidade legal clara, schema parcial',
  ],
  'Schema parcial + algún directorio activo': [
    'Partial schema + an active directory',
    'Schema parcial + diretório ativo',
  ],
  'Schema completo + llms.txt + directorios + sameAs': [
    'Complete schema + llms.txt + directories + sameAs',
    'Schema completo + llms.txt + diretórios + sameAs',
  ],
  '¿Hay reseñas estructuradas que los LLMs puedan citar?': [
    'Are there structured reviews LLMs can cite?',
    'Há avaliações estruturadas que os LLMs podem citar?',
  ],
  'Trustpilot, Google Business, G2, Capterra, Reclamos.cl. Testimonios B2B con firma pública. Casos de éxito con métricas cuantificadas. La reseña anónima no cuenta; el modelo no la cita si no puede verificarla.':
    [
      'Trustpilot, Google Business, G2, Capterra and Reclamos.cl. Publicly signed B2B testimonials and quantified case studies. Models cannot reliably cite unverifiable anonymous reviews.',
      'Trustpilot, Google Business, G2, Capterra e Reclamos.cl. Depoimentos B2B assinados publicamente e casos com métricas quantificadas. Modelos não citam de forma confiável avaliações anônimas não verificáveis.',
    ],
  'Sin reseñas estructuradas en ninguna plataforma': [
    'No structured reviews on any platform',
    'Sem avaliações estruturadas em plataformas',
  ],
  'Google Business activo < 20 reseñas': [
    'Active Google Business with <20 reviews',
    'Google Business ativo com <20 avaliações',
  ],
  '20–100 reseñas verificadas en 2+ plataformas': [
    '20–100 verified reviews on 2+ platforms',
    '20–100 avaliações verificadas em 2+ plataformas',
  ],
  '100+ reseñas + casos B2B con métricas': [
    '100+ reviews + B2B cases with metrics',
    '100+ avaliações + casos B2B com métricas',
  ],
  '¿Hay contenido que los LLMs puedan citar como autoridad?': [
    'Is there authoritative content LLMs can cite?',
    'Há conteúdo de referência que os LLMs podem citar?',
  ],
  'Blog técnico sostenido, Wikipedia ES robusta, prensa Tier-1, YouTube/podcast, listados sectoriales "Top X". El modelo cita lo que sus fuentes citaron. Sin presencia editorial verificable, no eres una autoridad para él.':
    [
      'A consistent technical blog, robust Spanish Wikipedia page, Tier-1 press, video/podcast and industry lists. Models cite what their sources cite; verifiable editorial presence builds authority.',
      'Blog técnico consistente, página robusta na Wikipédia em espanhol, imprensa Tier-1, vídeo/podcast e listas setoriais. Modelos citam o que suas fontes citam; presença editorial verificável constrói autoridade.',
    ],
  'Sitio comercial sin blog, sin Wikipedia, sin prensa': [
    'Commercial website without blog, Wikipedia or press',
    'Site comercial sem blog, Wikipédia ou imprensa',
  ],
  'Blog esporádico, LinkedIn de baja tracción': [
    'Occasional blog, low-traction LinkedIn',
    'Blog esporádico, LinkedIn com pouca tração',
  ],
  'Blog sostenido + LinkedIn fundadores + 3+ prensa': [
    'Consistent blog + founder LinkedIn + 3+ press mentions',
    'Blog consistente + LinkedIn dos fundadores + 3+ menções na imprensa',
  ],
  'Blog + YT + Wikipedia + 10+ prensa Tier-1': [
    'Blog + YouTube + Wikipedia + 10+ Tier-1 press mentions',
    'Blog + YouTube + Wikipédia + 10+ menções em imprensa Tier-1',
  ],
  '¿Está la marca donde se muestrea conversación?': [
    'Is the brand present where conversations are sampled?',
    'A marca está onde as conversas são amostradas?',
  ],
  'Redes sociales con tracción real, comunidad propia (Discord, newsletter) y presencia en foros sectoriales. Lo que se dice de tu marca en público alimenta directamente el muestreo de los modelos.':
    [
      'Active social networks, your own community (Discord, newsletter) and industry forums. Public discussion of your brand feeds model sampling.',
      'Redes sociais ativas, comunidade própria (Discord, newsletter) e fóruns setoriais. Conversas públicas sobre sua marca alimentam a amostragem dos modelos.',
    ],
  'Sin redes activas o < 100 seguidores': [
    'No active social accounts or <100 followers',
    'Sem redes ativas ou <100 seguidores',
  ],
  '1–2 redes con tracción media, sin foros': [
    '1–2 moderately active networks, no forums',
    '1–2 redes com tração média, sem fóruns',
  ],
  '3+ redes activas + alguna presencia en foros': [
    '3+ active networks + some forum presence',
    '3+ redes ativas + alguma presença em fóruns',
  ],
  'Comunidad propia + foros activos + plan editorial': [
    'Own community + active forums + editorial plan',
    'Comunidade própria + fóruns ativos + plano editorial',
  ],
  'Marca invisible para los modelos de IA. Prioridad en establecer identidad técnica básica antes de cualquier otra acción.':
    [
      'Brand invisible to AI. Establish basic technical identity before other actions.',
      'Marca invisível para a IA. Estabeleça a identidade técnica básica antes de outras ações.',
    ],
  Emergente: ['Emerging', 'Emergente'],
  'Algunas señales activas pero inconsistentes. Foco en cerrar las brechas de identidad y reputación antes de escalar editorial.':
    [
      'Some active but inconsistent signals. Close identity and reputation gaps before expanding editorial work.',
      'Alguns sinais ativos, mas inconsistentes. Feche lacunas de identidade e reputação antes de ampliar o trabalho editorial.',
    ],
  Consolidada: ['Established', 'Consolidada'],
  'Identidad sólida y reputación funcional. La oportunidad está en escalar editorial y abrir el frente social.':
    [
      'Strong identity and functional reputation. Expand editorial coverage and social presence.',
      'Identidade sólida e reputação funcional. Amplie a cobertura editorial e a presença social.',
    ],
  'Posición de referencia en el sector. El foco es el share-of-voice y la velocidad de actualización en los modelos.':
    [
      'A recognized industry position. Focus on share of voice and the speed of model updates.',
      'Posição de referência no setor. Foque em share of voice e velocidade de atualização nos modelos.',
    ],
  '03 / Diagnóstico': ['03 / Diagnosis', '03 / Diagnóstico'],
  'Cuatro dimensiones.': ['Four dimensions.', 'Quatro dimensões.'],
  'Diagnóstico 0–100.': ['0–100 diagnosis.', 'Diagnóstico 0–100.'],
  'Antes de prescribir cualquier acción, evaluamos la marca en cuatro dimensiones independientes. Cada una recibe 0–25 puntos y revela una brecha específica: el diagnóstico define la severidad de la intervención y la profundidad del primer reporte.':
    [
      'Before prescribing actions, we assess four independent dimensions with 0–25 points each. The diagnosis determines intervention severity and the depth of your first report.',
      'Antes de recomendar ações, avaliamos quatro dimensões independentes com 0–25 pontos cada. O diagnóstico define a severidade da intervenção e a profundidade do primeiro relatório.',
    ],
  'INTERPRETACIÓN DEL DIAGNÓSTICO': [
    'INTERPRETING THE DIAGNOSIS',
    'INTERPRETAÇÃO DO DIAGNÓSTICO',
  ],
  'No hay autoridad que desbloquear': [
    'There is no authority to unlock',
    'Não há autoridade para ampliar',
  ],
  'El AEO amplifica la autoridad que tu marca ya tiene; no la inventa. Si no existe contenido, reputación ni presencia citable, primero hay que construir esa base — medir una marca vacía no la mejora.':
    [
      'AEO amplifies existing authority. First build content, reputation and citable presence; measuring an empty brand does not improve it.',
      'O AEO amplia a autoridade existente. Primeiro construa conteúdo, reputação e presença citável; medir uma marca vazia não a melhora.',
    ],
  'Si el motor no puede leerte, no te cita': [
    'If engines cannot read you, they cannot cite you',
    'Se o motor não consegue ler você, não pode citar sua marca',
  ],
  'Contenido escondido tras JavaScript, dentro de imágenes o sin estructura no es accesible para los crawlers de IA. Antes de optimizar la visibilidad, hay que volver el sitio legible por máquinas.':
    [
      'Content hidden behind JavaScript, in images or without structure may be inaccessible to AI crawlers. Make your site machine-readable before optimizing visibility.',
      'Conteúdo oculto atrás de JavaScript, em imagens ou sem estrutura pode ser inacessível a crawlers de IA. Torne o site legível por máquinas antes de otimizar a visibilidade.',
    ],
  'YMYL: salud, finanzas, legal': [
    'YMYL: health, finance, legal',
    'YMYL: saúde, finanças, jurídico',
  ],
  'En temas sensibles los motores son más conservadores y citan solo fuentes muy autoritativas. Se avanza, pero la curva es más lenta y exige señales de E-E-A-T más fuertes que en otras categorías.':
    [
      'On sensitive topics, engines favor highly authoritative sources. Progress is slower and requires stronger E-E-A-T signals than other categories.',
      'Em temas sensíveis, motores priorizam fontes de alta autoridade. O avanço é mais lento e exige sinais de E-E-A-T mais fortes que em outras categorias.',
    ],
  'La visibilidad decae si se abandona': [
    'Visibility declines without maintenance',
    'A visibilidade cai sem manutenção',
  ],
  'El AEO es un ciclo continuo, no un proyecto de una sola vez: si se deja de mantener, las citas se erosionan con el tiempo. Esperar resultados permanentes sin sostener el trabajo no es realista.':
    [
      'AEO requires continuous work. Without maintenance, citations erode over time; lasting results depend on sustained effort.',
      'O AEO exige trabalho contínuo. Sem manutenção, as citações diminuem com o tempo; resultados duradouros dependem de esforço constante.',
    ],
  '07 / Límites': ['07 / Limitations', '07 / Limites'],
  'Cuándo el AEO no rinde,': [
    'When AEO underperforms,',
    'Quando o AEO não rende,',
  ],
  'y te lo decimos antes.': ['we tell you upfront.', 'avisamos antes.'],
  'El AEO no es magia ni aplica por igual a todas las marcas. Estos son los límites que validamos en el diagnóstico —antes de que inviertas— para no prometer lo que no podemos sostener.':
    [
      'AEO works differently for each brand. We validate these limits during diagnosis, before you invest, to make commitments we can support.',
      'O AEO funciona de forma diferente para cada marca. Validamos esses limites no diagnóstico, antes do investimento, para assumir compromissos sustentáveis.',
    ],
  'Experiencia directa con el tema. Los LLMs buscan autores con historial verificable, no redactores anónimos.':
    [
      'Direct subject experience. LLMs look for authors with verifiable track records.',
      'Experiência direta no assunto. LLMs procuram autores com histórico verificável.',
    ],
  'Dominio técnico demostrable. Schema.org, acreditaciones públicas, certificaciones y citas cruzadas.':
    [
      'Demonstrable technical expertise: Schema.org, public credentials, certifications and cross-citations.',
      'Domínio técnico demonstrável: Schema.org, credenciais públicas, certificações e citações cruzadas.',
    ],
  'Autoridad de dominio y editorial. Prensa Tier-1, Wikipedia, backlinks de sitios de referencia en el sector.':
    [
      'Domain and editorial authority: Tier-1 press, Wikipedia and backlinks from trusted industry sites.',
      'Autoridade de domínio e editorial: imprensa Tier-1, Wikipédia e backlinks de sites de referência do setor.',
    ],
  'Confianza verificable. Reseñas estructuradas, casos con métricas firmadas, identidad legal limpia.':
    [
      'Verifiable trust: structured reviews, signed case metrics and clear legal identity.',
      'Confiança verificável: avaliações estruturadas, casos com métricas assinadas e identidade legal clara.',
    ],
  '02 / Marco Heredado': ['02 / Inherited framework', '02 / Modelo herdado'],
  'al diagnóstico de Bison.': [
    "to Bison's diagnosis.",
    'ao diagnóstico do Bison.',
  ],
  'Google codificó en 2014 lo que los LLMs generalizaron en 2023: la autoridad no se declara, se acumula. E-E-A-T no es una lista de consejos SEO — es el modelo mental que los sistemas de IA heredaron para decidir a quién citar. Google lo confirmó en su guía de 2026 para AI Overviews y AI Mode: optimizar para su IA sigue siendo SEO. Por eso la base del método es SEO técnico; lo que sumamos es la medición en cada motor y la consistencia de tu entidad.':
    [
      "Google codified in 2014 what LLMs generalized in 2023: authority is accumulated. E-E-A-T is the framework AI systems inherited to decide whom to cite. Google's 2026 AI Overviews and AI Mode guide confirms that optimizing for its AI remains SEO. Our foundation is technical SEO, with measurement in each engine and entity consistency.",
      'O Google codificou em 2014 o que LLMs generalizaram em 2023: autoridade se acumula. E-E-A-T é o modelo que sistemas de IA herdaram para decidir quem citar. O guia de 2026 para AI Overviews e AI Mode confirma que otimizar para a IA do Google continua sendo SEO. Nossa base é SEO técnico, com medição em cada motor e consistência da entidade.',
    ],
  '· del framework SEO al framework AEO': [
    '· from the SEO framework to AEO',
    '· do modelo SEO ao AEO',
  ],
  '· del SEO al AEO': ['· from SEO to AEO', '· do SEO ao AEO'],
  'Las cuatro letras dejaron de ser una recomendación SEO.': [
    'These four letters go beyond SEO guidance.',
    'As quatro letras vão além de recomendações de SEO.',
  ],
  'Son el filtro de los modelos.': [
    "They are the models' filter.",
    'São o filtro dos modelos.',
  ],
  'En SEO, E-E-A-T influía en el ranking de páginas. En AEO, E-E-A-T determina si la marca existe como entidad citable. Un modelo que no puede resolver tu autoridad simplemente no te menciona.':
    [
      'In SEO, E-E-A-T influences page rankings. In AEO, it determines whether your brand is a citable entity. A model that cannot establish your authority may omit your brand.',
      'No SEO, E-E-A-T influencia a classificação das páginas. No AEO, determina se sua marca é uma entidade citável. Um modelo que não identifica sua autoridade pode omitir sua marca.',
    ],
  'La autoridad sigue siendo acumulativa, verificable y difícil de falsificar. No hay atajos: los LLMs heredaron los mismos sesgos de calidad que los algoritmos de búsqueda, solo los ejecutan más rápido.':
    [
      "Authority remains cumulative, verifiable and difficult to fake. LLMs inherit search algorithms' quality preferences and apply them faster.",
      'A autoridade continua cumulativa, verificável e difícil de falsificar. LLMs herdam as preferências de qualidade dos algoritmos de busca e as aplicam mais rápido.',
    ],
  'El diagnóstico 4D traduce E-E-A-T a cuatro dimensiones medibles: una nota 0–100, un mapa de brechas priorizado y las acciones específicas para cerrar cada brecha según tu tipo de empresa.':
    [
      'The 4D diagnosis translates E-E-A-T into four measurable dimensions: a 0–100 rating, prioritized gaps and specific actions suited to your business type.',
      'O diagnóstico 4D traduz E-E-A-T em quatro dimensões mensuráveis: nota 0–100, lacunas priorizadas e ações específicas para seu tipo de empresa.',
    ],
  '72 horas a tu primer diagnóstico.': [
    'Your first diagnosis in 72 hours.',
    'Seu primeiro diagnóstico em 72 horas.',
  ],
  'Sin compromiso.': ['No commitment.', 'Sem compromisso.'],
  'Solicitar reporte': ['Request a report', 'Solicitar relatório'],
  'Ver guía estratégica': ['View the strategy guide', 'Ver guia estratégico'],
  '08 / Dudas habituales': [
    '08 / Frequently asked questions',
    '08 / Perguntas frequentes',
  ],
  'Lo que más nos preguntan': [
    'What people ask most',
    'O que mais nos perguntam',
  ],
  'antes de empezar.': ['before getting started.', 'antes de começar.'],
  'Todo lo que necesitas saber antes de dar el primer paso.': [
    'What you need to know before taking the first step.',
    'O que você precisa saber antes do primeiro passo.',
  ],
  'Diagnóstico · Método · Secuencia': [
    'Diagnosis · Method · Sequence',
    'Diagnóstico · Método · Sequência',
  ],
  'De invisible a': ['From invisible to', 'De invisível a'],
  autoridad: ['authority', 'autoridade'],
  'En 72 horas: un diagnóstico 0–100 en cuatro dimensiones, las brechas exactas que te mantienen invisible y una secuencia de acciones ordenada por impacto para tu tipo de negocio.':
    [
      'In 72 hours: a 0–100 diagnosis in four dimensions, the gaps limiting your visibility and actions prioritized by impact for your business.',
      'Em 72 horas: diagnóstico 0–100 em quatro dimensões, lacunas que limitam sua visibilidade e ações priorizadas por impacto para seu negócio.',
    ],
  'Áreas de diagnóstico': ['Diagnosis areas', 'Áreas do diagnóstico'],
  'Técnica · Reputación · Editorial · Social': [
    'Technical · Reputation · Editorial · Social',
    'Técnica · Reputação · Editorial · Social',
  ],
  'Acciones en el playbook': ['Playbook actions', 'Ações no playbook'],
  'Con tiempo estimado e impacto medible': [
    'With estimated time and measurable impact',
    'Com tempo estimado e impacto mensurável',
  ],
  'Tipos de empresa': ['Business types', 'Tipos de empresa'],
  'Con secuencia de acciones propia': [
    'With their own action sequence',
    'Com sequência própria de ações',
  ],
  'Primer diagnóstico': ['First diagnosis', 'Primeiro diagnóstico'],
  'Diagnóstico · brechas · plan de acción': [
    'Diagnosis · gaps · action plan',
    'Diagnóstico · lacunas · plano de ação',
  ],
  DIAGNÓSTICO: ['DIAGNOSIS', 'DIAGNÓSTICO'],
  '¿Por dónde empezar?': ['Where to start?', 'Por onde começar?'],
  'Un diagnóstico en cuatro dimensiones devuelve una nota 0–100 y las acciones más urgentes priorizadas. Sin eso resuelto, cualquier otra mejora pierde efectividad.':
    [
      'A four-dimension diagnosis gives a 0–100 rating and prioritizes urgent actions. It provides the foundation for effective improvements.',
      'O diagnóstico em quatro dimensões dá uma nota 0–100 e prioriza ações urgentes. Ele fornece a base para melhorias eficazes.',
    ],
  '¿Qué jugada aplicar y cuándo?': [
    'Which action to take and when?',
    'Qual ação aplicar e quando?',
  ],
  'Una biblioteca de 25 acciones con esfuerzo estimado en horas, impacto en puntos de cobertura y la condición que activa la siguiente en la secuencia.':
    [
      'A library of 25 actions with effort in hours, impact in coverage points and criteria activating the next action.',
      'Uma biblioteca de 25 ações com esforço em horas, impacto em pontos de cobertura e critérios para ativar a próxima ação.',
    ],
  '¿En qué orden ejecutar?': ['In what order?', 'Em qual ordem executar?'],
  'Seis tipos de empresa con secuencias optimizadas. D2C retail no se ejecuta igual que SaaS B2B, ni una marca local igual que una plataforma.':
    [
      'Optimized sequences for six business types: D2C retail differs from B2B SaaS, as a local brand differs from a platform.',
      'Sequências otimizadas para seis tipos de empresa: varejo D2C difere de SaaS B2B, assim como uma marca local difere de uma plataforma.',
    ],
  '01 / Premisa': ['01 / Premise', '01 / Premissa'],
  'El AEO no se gana con': [
    'Success in AEO takes more than a',
    'O sucesso em AEO exige mais que uma',
  ],
  'jugada mágica.': ['magic move.', 'jogada mágica.'],
  'Si buscas tu marca en ChatGPT y no aparece, no es suerte: son señales que los modelos necesitan para citarte y que aún no existen, son inconsistentes o están mal estructuradas. Trabajando con clientes reales —de cervecerías artesanales a SaaS B2B— la conclusión es siempre la misma: la ventaja AEO se construye con consistencia técnica, producción editorial sostenida y acumulación de citas externas verificables.':
    [
      'If your brand is absent in ChatGPT, the signals models need may be missing, inconsistent or poorly structured. Across customers from craft breweries to B2B SaaS, the lesson is the same: AEO advantage comes from technical consistency, sustained editorial work and verifiable external citations.',
      'Se sua marca não aparece no ChatGPT, os sinais necessários podem estar ausentes, inconsistentes ou mal estruturados. De cervejarias artesanais a SaaS B2B, a lição é a mesma: a vantagem AEO vem da consistência técnica, produção editorial contínua e citações externas verificáveis.',
    ],
  'Aparecer en': ['Appearing in', 'Aparecer no'],
  'fue el primer round. Ser citado por la IA es el siguiente.': [
    'was the first round. Being cited by AI is next.',
    'foi a primeira etapa. Ser citado pela IA é a próxima.',
  ],
  'Domina la era de la IA': ['Lead in the AI era', 'Lidere na era da IA'],
  'Producto físico al consumidor final': [
    'Physical products for consumers',
    'Produtos físicos ao consumidor final',
  ],
  'Software de productividad o vertical': [
    'Productivity or vertical software',
    'Software de produtividade ou vertical',
  ],
  'Servicios profesionales': [
    'Professional services',
    'Serviços profissionais',
  ],
  'Consultoras, estudios, asesorías': [
    'Consultancies, firms and advisors',
    'Consultorias, escritórios e assessorias',
  ],
  'Marca local': ['Local brand', 'Marca local'],
  'Operación geográficamente acotada': [
    'Geographically limited operations',
    'Operação geograficamente limitada',
  ],
  'Tienda online B2C, catálogo extenso': [
    'B2C online store with a large catalog',
    'Loja online B2C com catálogo extenso',
  ],
  'Plataforma / Agencia': ['Platform / Agency', 'Plataforma / Agência'],
  'Vende servicios sobre otra capa': [
    'Services built on another platform',
    'Serviços sobre outra plataforma',
  ],
  'Ocho causas por las que': ['Eight reasons why', 'Oito motivos pelos quais'],
  'en la IA.': ['in AI.', 'na IA.'],
  'D2C · Salud & Wellness': [
    'D2C · Health & Wellness',
    'D2C · Saúde e bem-estar',
  ],
  'Reseñas · GBP': ['Reviews · GBP', 'Avaliações · GBP'],
  '90 días': ['90 days', '90 dias'],
  '120 días': ['120 days', '120 dias'],
  '180 días': ['180 days', '180 dias'],
  '60 días': ['60 days', '60 dias'],
  'Identidad técnica': ['Technical identity', 'Identidade técnica'],
  'Seguros · Turismo & Hospitalidad': [
    'Insurance · Tourism & Hospitality',
    'Seguros · Turismo e hotelaria',
  ],
  'Autoridad editorial': ['Editorial authority', 'Autoridade editorial'],
  'Cualquier vertical con foco geográfico': [
    'Any geographically focused vertical',
    'Qualquer vertical com foco geográfico',
  ],
  'Presencia local': ['Local presence', 'Presença local'],
  'GBP · Reseñas': ['GBP · Reviews', 'GBP · Avaliações'],
  'Retail online · Manufactura B2B': [
    'Online retail · B2B manufacturing',
    'Varejo online · Indústria B2B',
  ],
  'Schema · Reseñas': ['Schema · Reviews', 'Schema · Avaliações'],
  'MarTech & Agencias · Movilidad & AutoTech': [
    'MarTech & Agencies · Mobility & AutoTech',
    'MarTech e agências · Mobilidade e AutoTech',
  ],
  'Casos + Wikipedia': ['Case studies + Wikipedia', 'Casos + Wikipédia'],
  'Casos · LinkedIn': ['Case studies · LinkedIn', 'Casos · LinkedIn'],
  'Auditoría técnica': ['Technical audit', 'Auditoria técnica'],
  'AES-256 en reposo': ['AES-256 at rest', 'AES-256 em repouso'],
  'TLS 1.3 en tránsito': ['TLS 1.3 in transit', 'TLS 1.3 em trânsito'],
  'DPA estándar disponible': [
    'Standard DPA available',
    'DPA padrão disponível',
  ],
  'Auditoría en curso': ['Audit in progress', 'Auditoria em andamento'],
  'Cola de tareas con retry': [
    'Task queue with retries',
    'Fila de tarefas com novas tentativas',
  ],
  'Reconocimiento de entidades de marca': [
    'Brand entity recognition',
    'Reconhecimento de entidades de marca',
  ],
  'Scoring de posición y sentimiento': [
    'Position and sentiment scoring',
    'Pontuação de posição e sentimento',
  ],
  'Desambiguación de marca': ['Brand disambiguation', 'Desambiguação de marca'],
  'Mapa de fuentes citadas (citation graph)': [
    'Citation source map (citation graph)',
    'Mapa de fontes citadas (citation graph)',
  ],
  'API + dashboard en tiempo real': [
    'Real-time API + dashboard',
    'API + dashboard em tempo real',
  ],
  'Competidores monitoreados en paralelo': [
    'Competitors monitored in parallel',
    'Concorrentes monitorados em paralelo',
  ],
  'Evolución semanal con alertas': [
    'Weekly trends with alerts',
    'Evolução semanal com alertas',
  ],
  del: ['from your', 'da'],
  '¿Y tú?': ['Are you?', 'E você?'],
};
